import { EnumOption } from "./enum-option"

export const PWSource = {
    OES: 0,
    CBA: 1,
    DBA: 2,
    SCA: 3,
    AlternateSurvey: 4,
}

export const PWSourceList: EnumOption[] = [
    { value: PWSource.OES, label: 'OES' },
    { value: PWSource.CBA, label: 'CBA' },
    { value: PWSource.DBA, label: 'DBA' },
    { value: PWSource.SCA, label: 'SCA' },
    { value: PWSource.AlternateSurvey, label: 'Alternate Survey' },
]
